"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getAntIconSvgFile;

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.concat.js");

/**
 * Getting svg file of ant design icon by component name
 * @param icon
 */
function getAntIconSvgFile(icon) {
  var iconName = icon.type && icon.type.render && icon.type.render.displayName && icon.type.render.displayName.replace(/([A-Z])/g, function (g) {
    return "-".concat(g[0].toLowerCase());
  }).slice(1).split('-');
  var iconType = iconName && iconName.pop();
  iconName = iconName && iconName.join('-');

  if (!iconType || !iconName) {
    return '';
  }

  return require("@ant-design/icons-svg/inline-namespaced-svg/".concat(iconType, "/").concat(iconName, ".svg"));
}